//@ts-nocheck
import clsx from "clsx";
import * as React from "react";
import { RadioProps } from "../@types/radio";
import { HTMLAttributes, useMemo, useState } from "react";

function Radio(props: RadioProps) {
  const {
    id,
    value,
    label,
    checked,
    onChange,
    className,
    getValue,
    name = "radio",
    color = "primary",
  } = props;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e);
    const currentVal = e.target.value;
    getValue?.(value || currentVal);
  };

  return (
    <div className={clsx("form-check", color)}>
      <input
        id={id}
        name={name}
        value={value}
        type="radio"
        checked={checked}
        onChange={handleChange}
        className={clsx("form-check-input", className)}
      />
      <label className="form-check-label" htmlFor="flexCheckChecked">
        {label}
      </label>
    </div>
  );
}

const Group = (props: RadioProps & HTMLAttributes<HTMLInputElement>) => {
  const { children, id, getValue, defaultValue, ...other } = props;

  const [state, setState] = useState(defaultValue);

  const handleChangeValue = (value: string) => {
    setState(value);
  };

  const items = useMemo(() => {
    const itemsList = [];
    if(children) {
      const list = React.Children.toArray(children);

      for (let i in list) {
        if (list[i].props) {
          const {value, label} = list[i]?.props;
          if (list[i].type === Radio) {
            itemsList.push(
                <Radio
                    key={i}
                    value={value}
                    label={label}
                    id={`${id}-${i}`}
                    checked={state === value}
                    getValue={handleChangeValue}
                    {...other}
                />
            );
          }
        }
      }
    }
    return itemsList;
    
  }, [children, state]);

  return <React.Fragment>{items}</React.Fragment>;
};

Radio.Group = Group;
export default Radio;
